import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

export const StyledTableErrorState = styled(EmptyState)`
    min-height: 250px;
`;
